import html2canvas from 'html2canvas';
import {createPlayPlaceholder} from './placeholder';

function getElementSize(originalElement: HTMLElement, clonedElement: HTMLElement): {width: number; height: number} {
    const width = originalElement.offsetWidth || clonedElement.clientWidth || 320;
    const height = originalElement.offsetHeight || clonedElement.clientHeight || 180;
    return {width, height};
}

export async function replaceMediaElementsForSnapshot(node: HTMLElement, clonedNode: HTMLElement, quality: number): Promise<void> {
    const originalIframes = Array.from(node.querySelectorAll('iframe'));
    const clonedIframes = Array.from(clonedNode.querySelectorAll('iframe'));
    const originalVideos = Array.from(node.querySelectorAll('video'));
    const clonedVideos = Array.from(clonedNode.querySelectorAll('video'));

    const iframePromises = originalIframes.map(async (originalIframe, index) => {
        const clonedIframe = clonedIframes[index];
        if (!clonedIframe) return;

        const {width, height} = getElementSize(originalIframe, clonedIframe);

        try {
            const iframeDoc = originalIframe.contentDocument;
            if (!iframeDoc?.body) {
                throw new Error('No iframe body available');
            }

            const iframeCanvas = await html2canvas(iframeDoc.body, {
                logging: false,
                useCORS: true,
                scale: 1,
                imageTimeout: 0,
            });

            const img = document.createElement('img');
            img.src = iframeCanvas.toDataURL('image/jpeg', quality);
            img.style.cssText = window.getComputedStyle(originalIframe).cssText;
            img.style.width = `${width}px`;
            img.style.height = `${height}px`;

            clonedIframe.replaceWith(img);
        } catch {
            const fallback = createPlayPlaceholder(width, height, quality);
            fallback.style.cssText = window.getComputedStyle(originalIframe).cssText;
            fallback.style.width = `${width}px`;
            fallback.style.height = `${height}px`;
            clonedIframe.replaceWith(fallback);
        }
    });

    const videoPromises = originalVideos.map(async (originalVideo, index) => {
        const clonedVideo = clonedVideos[index];
        if (!clonedVideo) return;

        const {width, height} = getElementSize(originalVideo, clonedVideo);

        const fallback = createPlayPlaceholder(width, height, quality);
        fallback.style.cssText = window.getComputedStyle(originalVideo).cssText;
        fallback.style.width = `${width}px`;
        fallback.style.height = `${height}px`;
        clonedVideo.replaceWith(fallback);
    });

    await Promise.all([...iframePromises, ...videoPromises]);
}
